module.exports = __webpack_public_path__ + "static/media/multi-platform-moduleD4.df34401a.png";